module.exports = __webpack_public_path__ + "img/authentication-bg-dark.7d6bafdb.svg";